// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Messages/Common.proto (package time_tracking.messages.common, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { DeletedItemSelection } from "../Enumerations/DeletedItemSelection_pb";
import { file_Enumerations_DeletedItemSelection } from "../Enumerations/DeletedItemSelection_pb";
import { file_Options_ValidationFieldOptions } from "../Options/ValidationFieldOptions_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file Messages/Common.proto.
 */
export const file_Messages_Common: GenFile = /*@__PURE__*/
  fileDesc("ChVNZXNzYWdlcy9Db21tb24ucHJvdG8SHXRpbWVfdHJhY2tpbmcubWVzc2FnZXMuY29tbW9uIoUBChFEYXRlVGltZU9mZnNldER0bxI0Cgl0aW1lc3RhbXAYASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wQgXa1M0PABI6ChB0aW1lX3pvbmVfb2Zmc2V0GAIgASgLMhkuZ29vZ2xlLnByb3RvYnVmLkR1cmF0aW9uQgXa1M0PACKnAQoUTWVzc2FnZVRpbWVzdGFtcHNEdG8SLgoKY3JlYXRlZF9hdBgBIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLwoLbW9kaWZpZWRfYXQYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCmRlbGV0ZWRfYXQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIokBChFQYWdpbmF0aW9uRmlsdGVycxI0Cg9za2lwX2l0ZW1fY291bnQYASABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRI+Cg90YWtlX2l0ZW1fY291bnQYAiABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZUIIutTNDwMI6AciMAoUUGFnaW5hdGlvblN0YXRpc3RpY3MSGAoQdG90YWxfaXRlbV9jb3VudBgBIAEoBSIqCgdVdWlkRHRvEg8KB2hpZ2hfNjQYASABKAYSDgoGbG93XzY0GAIgASgGIrUBCh9VdWlkV2l0aERlbGV0ZWRJdGVtU2VsZWN0aW9uRHRvEjkKAmlkGAEgASgLMiYudGltZV90cmFja2luZy5tZXNzYWdlcy5jb21tb24uVXVpZER0b0IF2tTNDwASVwoWZGVsZXRlZF9pdGVtX3NlbGVjdGlvbhgCIAEoDjIwLnRpbWVfdHJhY2tpbmcuZW51bWVyYXRpb25zLkRlbGV0ZWRJdGVtU2VsZWN0aW9uQgXi1M0PAEIrqgIoTW9naS5UaW1lVHJhY2tpbmcuQ29tbW9uLk1lc3NhZ2VzLkNvbW1vbmIGcHJvdG8z", [file_google_protobuf_duration, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_Enumerations_DeletedItemSelection, file_Options_ValidationFieldOptions]);

/**
 * Represents a .NET DateTimeOffset in Protobuf.
 * A DateTimeOffset consists of a DateTime (Timestamp in Protobuf) along with a TimeSpan (Duration in Protobuf) that keeps track
 * of the original time zone offset the DateTime was recorded at. For example, 19:00 at Christmas 2024 would be recorded as
 * 2024-12-24T18:00:00.0000000+00:00 in UTC DateTimeOffset and 2024-12-24T19:00:00.0000000+01:00 in Local Time DateTimeOffset.
 *
 * @generated from message time_tracking.messages.common.DateTimeOffsetDto
 */
export type DateTimeOffsetDto = Message<"time_tracking.messages.common.DateTimeOffsetDto"> & {
  /**
   * The date and time part of the DateTimeOffset.
   *
   * @generated from field: google.protobuf.Timestamp timestamp = 1;
   */
  timestamp?: Timestamp | undefined;

  /**
   * The offset in minutes from UTC. This means that if the value was recorded by using DateTimeOffset.UtcNow, this will always be
   * zero, but if the value was recorded using DateTimeOffset.Now, it will contain the offset of the time_stamp from UTC.
   *
   * @generated from field: google.protobuf.Duration time_zone_offset = 2;
   */
  timeZoneOffset?: Duration | undefined;
};

/**
 * Describes the message time_tracking.messages.common.DateTimeOffsetDto.
 * Use `create(DateTimeOffsetDtoSchema)` to create a new message.
 */
export const DateTimeOffsetDtoSchema: GenMessage<DateTimeOffsetDto> = /*@__PURE__*/
  messageDesc(file_Messages_Common, 0);

/**
 * The date and time timestamps of items.
 *
 * @generated from message time_tracking.messages.common.MessageTimestampsDto
 */
export type MessageTimestampsDto = Message<"time_tracking.messages.common.MessageTimestampsDto"> & {
  /**
   * Specifies when the item was created in UTC time.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 1;
   */
  createdAt?: Timestamp | undefined;

  /**
   * Specifies when the item was last modified in UTC time.
   *
   * @generated from field: google.protobuf.Timestamp modified_at = 2;
   */
  modifiedAt?: Timestamp | undefined;

  /**
   * Specifies when the item was deleted in UTC time.
   *
   * @generated from field: google.protobuf.Timestamp deleted_at = 3;
   */
  deletedAt?: Timestamp | undefined;
};

/**
 * Describes the message time_tracking.messages.common.MessageTimestampsDto.
 * Use `create(MessageTimestampsDtoSchema)` to create a new message.
 */
export const MessageTimestampsDtoSchema: GenMessage<MessageTimestampsDto> = /*@__PURE__*/
  messageDesc(file_Messages_Common, 1);

/**
 * Contains filter settings to apply pagination to item queries.
 *
 * @generated from message time_tracking.messages.common.PaginationFilters
 */
export type PaginationFilters = Message<"time_tracking.messages.common.PaginationFilters"> & {
  /**
   * Specifies the amount of items to skip in the query.
   *
   * @generated from field: google.protobuf.Int32Value skip_item_count = 1;
   */
  skipItemCount?: number | undefined;

  /**
   * Specifies how many of the unskipped items to return.
   *
   * @generated from field: google.protobuf.Int32Value take_item_count = 2;
   */
  takeItemCount?: number | undefined;
};

/**
 * Describes the message time_tracking.messages.common.PaginationFilters.
 * Use `create(PaginationFiltersSchema)` to create a new message.
 */
export const PaginationFiltersSchema: GenMessage<PaginationFilters> = /*@__PURE__*/
  messageDesc(file_Messages_Common, 2);

/**
 * Contains statistics about the pagination state of a query.
 *
 * @generated from message time_tracking.messages.common.PaginationStatistics
 */
export type PaginationStatistics = Message<"time_tracking.messages.common.PaginationStatistics"> & {
  /**
   * Declares the total number of items that would have been returned if no pagination had been applied.
   *
   * @generated from field: int32 total_item_count = 1;
   */
  totalItemCount: number;
};

/**
 * Describes the message time_tracking.messages.common.PaginationStatistics.
 * Use `create(PaginationStatisticsSchema)` to create a new message.
 */
export const PaginationStatisticsSchema: GenMessage<PaginationStatistics> = /*@__PURE__*/
  messageDesc(file_Messages_Common, 3);

/**
 * Represents a GUID in protobuf. Instead of serializing GUIDs to strings two 64 bit integers are used to contain the 128 GUID bits.
 * The integers contain the little-endian encoded low or high 8 bytes respectively.
 *
 * @generated from message time_tracking.messages.common.UuidDto
 */
export type UuidDto = Message<"time_tracking.messages.common.UuidDto"> & {
  /**
   * The high 8 bytes of the GUID in little-endian form.
   *
   * @generated from field: fixed64 high_64 = 1;
   */
  high64: bigint;

  /**
   * The low 8 bytes of the GUID in little-endian form.
   *
   * @generated from field: fixed64 low_64 = 2;
   */
  low64: bigint;
};

/**
 * Describes the message time_tracking.messages.common.UuidDto.
 * Use `create(UuidDtoSchema)` to create a new message.
 */
export const UuidDtoSchema: GenMessage<UuidDto> = /*@__PURE__*/
  messageDesc(file_Messages_Common, 4);

/**
 * Contains a GUID alongside a selection for deleted items for queries that only return a single item.
 *
 * @generated from message time_tracking.messages.common.UuidWithDeletedItemSelectionDto
 */
export type UuidWithDeletedItemSelectionDto = Message<"time_tracking.messages.common.UuidWithDeletedItemSelectionDto"> & {
  /**
   * The id of the item to query.
   *
   * @generated from field: time_tracking.messages.common.UuidDto id = 1;
   */
  id?: UuidDto | undefined;

  /**
   * Determines whether to return the item in case it has been deleted.
   *
   * @generated from field: time_tracking.enumerations.DeletedItemSelection deleted_item_selection = 2;
   */
  deletedItemSelection: DeletedItemSelection;
};

/**
 * Describes the message time_tracking.messages.common.UuidWithDeletedItemSelectionDto.
 * Use `create(UuidWithDeletedItemSelectionDtoSchema)` to create a new message.
 */
export const UuidWithDeletedItemSelectionDtoSchema: GenMessage<UuidWithDeletedItemSelectionDto> = /*@__PURE__*/
  messageDesc(file_Messages_Common, 5);

